import { useEffect, useRef, useState } from 'react';

function Stat({ value, label }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setShown(true); io.disconnect(); } });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className="px-5 sm:px-8 py-6 border border-border rounded-2xl card-surface text-center">
      <div className={`font-display uppercase text-4xl sm:text-5xl text-[hsl(43_92%_56%)] transition-all duration-700 ${shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}>{value}</div>
      <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground mt-2">{label}</div>
    </div>
  );
}

export default function BigStats({ stats }) {
  const joined = stats?.total_joined || 131312;
  const formatted = joined >= 1000 ? `${Math.round(joined / 1000)}K+` : `${joined}+`;
  return (
    <section className="bg-[hsl(0_0%_4%)] section-pad relative">
      <div className="container-x">
        <div className="grid gap-3 sm:gap-4 grid-cols-2 lg:grid-cols-4">
          <Stat value={formatted} label="Active Traders" />
          <Stat value="5" label="Wealth Campuses" />
          <Stat value="24/7" label="Live Signals" />
          <Stat value="$1M+" label="Earned by Mentors" />
        </div>
      </div>
    </section>
  );
}
